import { fetchResponseForParameter } from './api-helper';

const companySearchUrl = `${process.env.REACT_APP_GSP_COMPANIES_API}`;

export const companySearch = async (parameter) => {
  const companies = await fetchResponseForParameter(companySearchUrl, parameter);
  return companies || [];
};
